<template lang="html">
  <div>
    <table class="table table_text-center operations-list">
      <thead>
      <tr>
        <th class="operation__date">{{ $t('Дата') }}</th>
        <th class="operation__status">{{ $t('Статус') }}</th>
        <th class="operation__corr">{{ $t('Тип платежа') }}</th>
        <th class="operation__refill">{{ $t('Сумма') }}</th>
        <th class="operation__refill" v-if="showFees">{{ $t('Комиссия') }}</th>
        <th class="operation__repeat">{{ $t('Управление') }}</th>
      </tr>
      </thead>
      <tbody>
      <template v-for="document in showDocuments">
        <tr :class="{'history-document-details-visible': isDetailsVisible(document.id)}">
          <td class="operation__date">

            <div class="details-toggler" @click.prevent="toggleDetails(document.id)">
              <div class="details-toggler-icon-plus"></div>
              <a class="operation-details_toggle" href="#"
                 @click.stop.prevent="toggleDetails(document.id)">
                <strong>{{ tsFormat(document.created, 'D.MM.Y') }}</strong>
                <br/>
                {{ tsFormat(document.created, 'HH:mm:ss') }}
              </a>
            </div>

          </td>
          <td style="vertical-align: middle">
            <template v-if="document.virtual">
              <inline-svg :src="require('./icons/documents-tree-dashed.svg')" width="27" height="27"/>
            </template>
            <template v-else>
              <legacy-history-document-status-icon :document="document"
                                                   :title-executed="$t('Платеж исполнен.')"
                                                   :title-manual-process="$t('Платеж в обработке.')"
                                                   :title-declined="$t('Платеж отклонен.')"
                                                   :title-inprocess="$t('Платеж в обработке.')"
                                                   :title-virtual="$t('Виртуальный платеж.')"
              ></legacy-history-document-status-icon>
            </template>
          </td>
          <td class="operation__corr">
            <document-beneficiary-details :document="document"></document-beneficiary-details>
          </td>
          <td class="word-nowrap">
            <template v-if="document.selfExchange">
              <div class="outgoing_payment">{{ moneyFormat(document.amount, document.currency) }}
                {{
                  frontofficeCurrencyFilter(document.currency, true)
                }}
              </div>
              <div class="incoming_payment" style="margin-top:6px;">{{
                  moneyFormat(document.destAmount, document.destCurrency)
                }} {{ frontofficeCurrencyFilter(document.destCurrency, true) }}
              </div>
            </template>
            <template v-if="!document.selfExchange">
              <div :class="amountClass(document.outgoing)">{{
                  moneyFormat(document.actualAmount,
                    document.actualCurrency)
                }} {{ frontofficeCurrencyFilter(document.actualCurrency, true) }}
              </div>

            </template>
          </td>
          <td v-if="showFees" class="word-nowrap" style="vertical-align: middle;">
            {{ moneyFormat(document.tax, document.currency) }} {{ frontofficeCurrencyFilter(document.currency, true) }}
          </td>
          <td class="operation__repeat">
            <legacy-history-document-controls :document="document"
                                              :correspondent-search-url="document.historyBeneficiarySearchUrl"
                                              :repeat-url="repeatUrl(document)"></legacy-history-document-controls>
          </td>
        </tr>
        <tr is="document-details"
            v-show="isDetailsVisible(document.id)"
            :document="document"
            :show-fees="showFees"></tr>
      </template>

      </tbody>
    </table>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import DocumentStatusIcon from '@/views/pages/finance/history/DocumentStatusIcon.vue';
import {formatUnixDateFilter} from '@/models/filters/datetime';
import {MoneyFormatFilter} from '@/models/filters/money';
import DocumentBeneficiaryDetails
  from '@/views/pages/finance/history/DocumentBeneficiaryDetails.vue';
import DocumentControls from '@/views/pages/finance/history/DocumentControls.vue';
import DocumentDetails from '@/views/pages/finance/history/DocumentDetails.vue';
import LegacyHistoryDocumentStatusIcon
  from "@/views/pages/finance/legacy-history/LegacyHistoryDocumentStatusIcon.vue";
import LegacyHistoryDocumentControls
  from "@/views/pages/finance/legacy-history/LegacyHistoryDocumentControls.vue";

import InlineSvg from 'vue-inline-svg';
import {frontofficeCurrencyFilter} from "@/models/core/currency";

@Component({
  methods: {frontofficeCurrencyFilter, tsFormat: formatUnixDateFilter,
    moneyFormat: MoneyFormatFilter,},
  components: {
    LegacyHistoryDocumentControls,
    LegacyHistoryDocumentStatusIcon,
    DocumentDetails, DocumentControls, DocumentBeneficiaryDetails, DocumentStatusIcon,
    InlineSvg,
  },
  name: 'history-table',
})
export default class HistoryTable extends Vue {
  @Prop({
    default: () => [],
  })
  documents: any

  @Prop({default: false})
  showFees!: boolean

  details = {}

  amountClass(outcome = true): any {
    return outcome ? 'outgoing_payment' : 'incoming_payment';
  }

  repeatUrl(document: any): string {
    return document.repeatUrl;
  }

  isDetailsVisible(id: any): boolean {
    if (!(id in this.details)) Vue.set(this.details, id, false);

    return this.details[id];
  }

  toggleDetails(id: any) {
    Vue.set(this.details, id, !this.details[id]);
    // this.details[id] = ! this.details[id];
  }

  get showDocuments(): any {
    // if (this.documents && $.isArray(this.documents) && (this.documents.length > 0))
    //     return this.documents;
    return this.documents ? this.documents : [];
  }
}
</script>

<style scoped lang="less">

</style>

<i18n>
{
  "en": {
    "Дата": "Date",
    "Статус": "Status",
    "Тип платежа": "Payment type",
    "Сумма": "Amount",
    "Комиссия": "Commission",
    "Управление": "Control",
    "Платеж исполнен.": "Payment executed.",
    "Платеж отклонен.": "Payment rejected.",
    "Платеж в обработке.": "Payment in process.",
    "Виртуальный платеж.": "Virtual payment."
  }
}
</i18n>
